import styled from 'styled-components'

export const ModalFooter = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`

export const Divider = styled.hr`
	border: none;
	border-top: 1px solid #e9ecef;
	margin: 1.25rem 0;
`

export const SectionLabel = styled.div`
	font-size: 0.7rem;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: #9ca3af;
	margin-bottom: 0.875rem;
`

export const VisibilityRow = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 1.5rem;
`

export const VisibilityText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`

export const VisibilityTitle = styled.span`
	font-size: 0.95rem;
	font-weight: 600;
	color: #212529;
`

export const VisibilityDescription = styled.span`
	font-size: 0.8rem;
	color: #6c757d;
	line-height: 1.5;
`

export const ToggleWrapper = styled.div`
	position: relative;
	flex-shrink: 0;
	margin-top: 2px;
`

export const ToggleInput = styled.input`
	opacity: 0;
	width: 0;
	height: 0;
	position: absolute;
`

export const ToggleSlider = styled.label<{ $checked: boolean; $loading: boolean }>`
	display: block;
	width: 44px;
	height: 24px;
	background: ${props => props.$checked ? '#198754' : '#dee2e6'};
	border-radius: 24px;
	cursor: ${props => props.$loading ? 'wait' : 'pointer'};
	transition: background 0.2s ease;
	opacity: ${props => props.$loading ? 0.6 : 1};
	position: relative;

	&::after {
		content: '';
		position: absolute;
		top: 3px;
		left: ${props => props.$checked ? '23px' : '3px'};
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background: white;
		transition: left 0.2s ease;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
	}
`

export const VisibilityStatus = styled.span<{ $isPublic: boolean }>`
	font-size: 0.75rem;
	font-weight: 600;
	color: ${props => props.$isPublic ? '#198754' : '#6c757d'};
	margin-top: 0.5rem;
	display: block;
`
